import React, {Component} from "react";

import CommonHelper from "../../libs/CommonHelper";

import LandingPage from "./LandingPage";

import Header from "../elements/Header";

import MessageGate from "../ui-kit/MessageGate";
import Layout from "../ui-kit/Layout";

class Home extends Component
{
  render ()
  {
    return (
      <Layout
        header={<Header />}
      >
        <MessageGate key={"home"}>
          {
            CommonHelper.isExist(this.props.children)
            ? this.props.children
            : <LandingPage />
          }
        </MessageGate>

      </Layout>
    );
  }
}

export default Home;